import { AiChatContext as e } from "../context/AiChatContext.mjs";
import { useContext as t, useEffect as n } from "react";
import { AiPageKind as r } from "@maat/api-ai/types";
//#region src/hooks/usePublishAiListingPage.ts
var i = ({ listingId: i, title: a, checkIn: o, checkOut: s, guests: c }) => {
	let l = t(e)?.publishPage;
	n(() => {
		if (!l || !i || !a) return;
		let e = o && s && s > o;
		return l({
			title: a,
			context: {
				kind: r.Listing,
				listingId: i,
				...e ? {
					checkIn: o,
					checkOut: s
				} : {},
				...c ? { guests: c } : {}
			}
		});
	}, [
		l,
		i,
		a,
		o,
		s,
		c
	]);
};
//#endregion
export { i as usePublishAiListingPage };
